import { QRCodeSVG } from "qrcode.react";
import { pontosDeRonda, appConfig } from "../../data/mock";
import { Printer } from "lucide-react";

const BASE_URL = window.location.origin;

export default function QRCodesPage() {
    return (
        <div className="min-h-screen bg-[#040914] text-white">
            {/* Toolbar — hidden when printing */}
            <div className="no-print flex items-center justify-between p-4 border-b border-white/10 bg-[#0a1128]">
                <div>
                    <p className="text-xs text-slate-400 uppercase tracking-widest font-semibold">
                        {appConfig.nomeComercial}
                    </p>
                    <h1 className="text-xl font-bold mt-0.5">QR Codes de Ronda</h1>
                    <p className="text-sm text-slate-400">
                        {pontosDeRonda.length} pontos · {appConfig.condominioPadrao}
                    </p>
                </div>
                <button
                    onClick={() => window.print()}
                    className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-emerald-500 text-black font-semibold text-sm hover:bg-emerald-400 transition"
                >
                    <Printer className="w-4 h-4" />
                    Imprimir / Salvar PDF
                </button>
            </div>

            {/* Grid de QR codes */}
            <div className="p-6 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5 print:grid-cols-3 print:gap-4 print:p-4">
                {pontosDeRonda.map((ponto) => {
                    const url = `${BASE_URL}/ronda?ponto=${ponto.id}`;
                    return (
                        <div
                            key={ponto.id}
                            className="flex flex-col items-center rounded-2xl border border-white/10 bg-[#0a1128] p-5 gap-3 print:border print:border-gray-300 print:bg-white print:rounded-lg print:p-4"
                        >
                            <div className="bg-white p-2 rounded-xl">
                                <QRCodeSVG
                                    value={url}
                                    size={140}
                                    level="H"
                                    includeMargin={false}
                                />
                            </div>
                            <div className="text-center">
                                <span className="inline-block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1 print:text-gray-400">
                                    Ponto {ponto.ordem}
                                </span>
                                <p className="font-bold text-sm leading-tight print:text-gray-900">
                                    {ponto.nome}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>

            <style>{`
                @media print {
                    .no-print { display: none !important; }
                    body { background: white !important; color: black !important; }
                    * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                }
            `}</style>
        </div>
    );
}
